export default function reloadApp() {
  window.location.reload();
}
